import type { UseProfile } from "@/composables/useProfile";
import { browser } from "@/services/browser";

/*
 * The organization of the last route the user accessed that carried an
 * `orgId` param, persisted per account in the browser's local storage.
 *
 * The route is the source of truth for the organization being viewed
 * (Routine.vue records it from the route's `orgId` param); this value only
 * serves screens whose route carries no organization — e.g. the settings
 * pages under `/settings/preferences`, or the OAuth redirect landing — so
 * they keep operating on the organization the user last worked in.
 */

const key = (profile: UseProfile): string =>
  `${profile.user.accountId}/organization:last`;

export const getLastAccessedOrganization = (
  profile: UseProfile
): string | undefined =>
  browser.store.get<string | undefined>(key(profile), undefined, {
    format: "raw",
  }) || undefined;

export const setLastAccessedOrganization = (
  profile: UseProfile,
  organizationId: string
): void => browser.store.set(key(profile), organizationId, { format: "raw" });
